<template>
  <WorkPackageSubPageModule
    :workpackage="workpackage"
    :isMobile="isMobile"
    :location="location"
    :loading="loading"
    :is_create_screen="is_create"
    :save_btn_loading="save_btn_loading"
    :background_color="workpackage_bg_hex"
    :foreground_color="workpackage_fg_hex"
    header_icon="pencil"
    :header_text_short="$t('WorkpackageRework.Info.Log.Header').toUpperCase()"
    :header_text_long="$t('WorkpackageRework.Info.Log.Header').toUpperCase() + '.' + $t('WorkpackageRework.Info.Log.Entry')"
    @headerCancel="$router.push({
      name: `${location}WorkPackageLogList`
      })"
    @headerSave="
    save_btn_loading = true,
    createLogListComment({
        project_id: project_id,
        train_id: train_id,
        taktarea_id: taktarea_id,
        twaggon_id: twaggon_id,
        wbgroup_id: wbgroup_id,
        wbline_id: wbline_id,
        workpackage_id: workpackage_id,
        backlog: backlog,
        data: {comment: new_entry}
      }).then(() => {
        save_btn_loading = false,
        $router.push({
          name: `${location}WorkPackageLogList`,
          params: { nav_back: $route.params.nav_back},
          })
        })
    "
  >
    <template #body>
      <TextArea
        :value="new_entry"
        :label="$t('WorkpackageRework.Info.Log.Comment')"
        :placeholder="`Write your ${$t('WorkpackageRework.Info.Log.Comment')}`"
        :max_char_count="300"
        :height="170"
        :background_color="workpackage_bg_hex"
        :foreground_color="workpackage_fg_hex"
        @change="new_entry=$event"
      />
    </template>
  </WorkPackageSubPageModule>
</template>

<script>
import { WorkPackageReworkMixin } from '@/mixins/WorkPackageRework.mixin.js'
import { mapActions } from 'vuex';
import WorkPackageSubPageModule from '@/modules/WorkPackageWIP/WorkPackageSubPageModule.module.vue';
import TextArea from '@/components/WorkPackageWIP/TextArea.component.vue';

  export default {
    props: ['location'],
    components: {
      WorkPackageSubPageModule,
      TextArea
    },
    mixins: [
      WorkPackageReworkMixin
    ],
    data: () => ({
      new_entry: "",
    }),
    methods: {
      ...mapActions('WorkPackageLogList', [
        'createLogListComment',
      ]),
    },
  }
</script>
<style>
</style>
